$(document).ready(function () {

    /** Load More */
    var $moreLink = $('a.load-more');
    if ($moreLink.length === 1) {
        var loading = false,
            container = $('.load-container');
        $moreLink.attr('pageno', '1').on('click', function (e) {
            if (loading) {
                return false;
            }
            var pageno = parseInt($(this).attr('pageno')) + 1,
                title = $(this).html(),
                xhrData = {};
            $(this).html('...');
            loading = true;
            xhrData.xhr = 'true';
            xhrData.pageNo = pageno;
            $moreLink.attr('pageno', pageno);
            var url = runningurl + requestReal;
            $.post(url, xhrData,
                function (result, status, xhr) {
                    if (status === 'success' && xhr.status === 200) {
                        if (result.active) {
                            if (result.items != '') {
                                container.append(result.items);
                            }
                        } else {
                            $moreLink.hide();
                        }
                    }
                    loading = false;
                    $moreLink.html(title);
                });
        });
    }

    /** Plugin settings */
    $('.clients-list').slick({
        dots: true,
        arrows: false,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });

    $('.blog-slider').slick({
        dots: false,
        arrows: false,
        speed: 600,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    autoplay: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    autoplay: true
                }
            }
        ]
    });

    $(".mobile-menu").click(function () {
        $("#navbarSupportedContent").addClass('show-time', 1000);
    });
    $(".menu-close").click(function () {
        $("#navbarSupportedContent").removeClass('show-time', 1000);
    });
    $('.swipebox').swipebox({
        useCSS: true, // false will force the use of jQuery for animations
        useSVG: true, // false to force the use of png for buttons
        initialIndexOnArray: 0, // which image index to init when a array is passed
        hideCloseButtonOnMobile: false, // true will hide the close button on mobile devices
        removeBarsOnMobile: true, // false will show top bar on mobile devices
        hideBarsDelay: 3000, // delay before hiding bars on desktop
        videoMaxWidth: 1140, // videos max width
        beforeOpen: function () {}, // called before opening
        afterOpen: null, // called after opening
        afterClose: function () {}, // called after closing
        loopAtEnd: false // true will return to the first image after the last image is reached
    });
});